import React from 'react';
import CmsMedia from '../cms/CmsMedia';
import { CmsAsset } from '../../integrations/contentful/types';
import DivButton from '../a11y/DivButton';
import HorizontalCardList, { VisibleCards } from '../common/HorizontalCardList';
import { baseXInPixels } from '../../styles/theme';

interface MediaCarouselWrapperProps {
  onMediaClick?: (media: CmsAsset) => void;
  media: CmsAsset;
  children?: React.ReactNode;
}

export const MediaItemWrapper: React.FunctionComponent<
  MediaCarouselWrapperProps
> = ({ children, onMediaClick, media, ...rest }) => {
  return (
    <>
      {onMediaClick ? (
        <DivButton
          onClick={() => onMediaClick && onMediaClick(media)}
          {...rest}
        >
          {children}
        </DivButton>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

interface CmsMediaCarouselProps {
  mediaList: CmsAsset[];
  onMediaClick?: (media: CmsAsset) => void;
}

const imageWidthBase = [40, 95];
const imageHeightBase = [29, 60];

const CmsMediaCarousel: React.FunctionComponent<CmsMediaCarouselProps> = ({
  mediaList,
  onMediaClick
}) => {
  return (
    <div>
      <HorizontalCardList visibleCards={VisibleCards.One}>
        {mediaList.map((media) => {
          return (
            <MediaItemWrapper
              media={media}
              onMediaClick={onMediaClick}
              key={media.sys.id}
              data-cy="cms-media-carousel-item"
            >
              <CmsMedia
                media={media}
                crop
                hover
                width={[
                  baseXInPixels(imageWidthBase[0]),
                  baseXInPixels(imageWidthBase[1])
                ]}
                height={[
                  baseXInPixels(imageHeightBase[0]),
                  baseXInPixels(imageHeightBase[1])
                ]}
                borderRadius={1}
              />
            </MediaItemWrapper>
          );
        })}
      </HorizontalCardList>
    </div>
  );
};

export default CmsMediaCarousel;
